import { useOldMenu } from "./old-menu-context";
import { motion } from "motion/react";
export const OldMenuOverlay = () => {
  const { closeMenu } = useOldMenu();

  return (
    <motion.button
      className="bg-black/60 w-full left-0 top-0 bottom-0 h-full right-0 absolute lg:h-screen lg:w-screen lg:fixed lg:top-[200px]"
      onClick={closeMenu}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, delay: 0.2 }}
    />
  );
};
